module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Brush-ce0b15c2589c62a0f627655dc2ad7293.svg";